import { h, Component } from 'preact';

import style from './style.less';
import { configure } from '../../../config';
import { Select, Option } from '@cube/blocks';
import { trackingProvider, trackEvent, DIMENSION, INPUT_KEYS } from '@cube/track';

/** A customize drop down for clusters
 *  @param {String}  title		the title to display
 *  @param {Object}  link			the link url and label to display if applicable
 */
@configure([
	'singleCube.customizeCategories',
	'singleCube.browseCategories'
])
@trackingProvider({
	[DIMENSION.cubecomponent]: 'Customize'
})
export default class Customize extends Component {
	onChange = ({ value }) => {
		trackEvent(this.context, {
			[INPUT_KEYS.action]: 'click',
			[DIMENSION.text]: value
		});
		if (this.props.customizeKey) localStorage.setItem(this.props.customizeKey, value);
		this.props.onCustomize(this.props.browseCategories[value]);
	};

	constructor() {
		super();
		this.onChange = this.onChange.bind(this);
	}

	render({ customizeCategories, browseCategories, customizeKey, hideCustomizeLabel }) {
		let selectedValue = localStorage.getItem(customizeKey) || customizeCategories[0];
		return (
			<Select
				iconPosition="right"
				class={style.select}
				displayValue={hideCustomizeLabel ? '' : 'Customize'}
				onChange={this.onChange}
				value={selectedValue}
				icon="cog-cube"
				anchor="right"
				disableSelected
			>
				{
					customizeCategories.map(category => (
						<Option value={category} title={browseCategories[category].title} iconPosition="right" />
					))
				}
			</Select>
		);
	}
}
export function customizeProps(props) {
	// if props have feed or no feeds, then just return props
	if (props.feed || !props.customizeCategories || props.customizeCategories.length === 0) return props;
	// Check for feed
	let category =
		(props.customizeKey && props.browseCategories[localStorage.getItem(props.customizeKey)]) //stored value
		|| props.browseCategories[props.defaultFeed] //config set default
		|| Object.keys(props.browseCategories)[0]; //first item
	return { ...props, ...category };
}
